import React from 'react';
import Group from '../assets/Ellipse 31.png'
import '../styles/GroupDiscount.css';

const GroupDiscountBanner = () => {
  return (
    <div style={{backgroundColor:'#FFFFFF',borderRadius:'30px',padding:'15px',fontWeight:'500'}}>
      <div className='GroupDisc'>
        <div style={{display:'flex',flexDirection:'row'}}>
          <div>
            <img src={Group} style={{padding:'15px'}}/>
          </div>
          <div style={{padding:'15px'}}>
            <div style={{fontSize:'200%'}}>Upto 20% Extra Discounts</div>
            <div style={{color:'#777777'}}>applicable for 8 guest or more</div>
          </div>
        </div>
        <button style={{width:'100%',color:'#321e5d',borderRadius:'30px',border:'solid 1px #541c9c',padding:'15px',fontWeight:'700'}}>Request Group Discount</button>
      </div>
    </div>
  );
};

export default GroupDiscountBanner;
